export default {
    id: null,
    firstName: "",
    lastName: "",
    numAssociatedAcademics: null,
    academics: null,
};
